const NativeZoomContainer = () => {
    throw new Error("NativeZoomContainer is not currently supported for web. ");
};
export default NativeZoomContainer;
